import plData from './pl/index.js'

export default {
    'pl': plData,
    'en': plData
}